var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const rgbRe = /^\s*rgb\(\s*(-?[0-9]+%?)\s*,\s*(-?[0-9]+%?)\s*,\s*(-?[0-9]+%?)\s*\)\s*$/;
const rgbaRe = /^\s*rgba\(\s*(-?[0-9]+%?)\s*,\s*(-?[0-9]+%?)\s*,\s*(-?[0-9]+%?)\s*,\s*(0|0?\.[0-9]+|1(?:\.0+)?)\s*\)\s*$/;
const hslRe = /^\s*hsl\(\s*(-?[0-9]+)\s*,\s*(-?[0-9]+%)\s*,\s*(-?[0-9]+%)\s*\)\s*$/;
const hslaRe = /^\s*hsla\(\s*(-?[0-9]+)\s*,\s*(-?[0-9]+%)\s*,\s*(-?[0-9]+%)\s*,\s*(0|0?\.[0-9]+|1(?:\.0+)?)\s*\)\s*$/;
function decimalToValueAndUnit(value) {
  const match = value.match(/([0-9]+)\s*(%)?/);
  if (!match) {
    return [0, ""];
  }
  return [parseInt(match[1]), match[2] || ""];
}
function clip(value, upper, lower = 0, cycle = false) {
  const ensuredLower = Math.min(lower, upper);
  const ensuredUpper = Math.max(upper, lower);
  if (!cycle) {
    return Math.min(ensuredUpper, Math.max(ensuredLower, value));
  }
  const dMinMax = ensuredUpper - ensuredLower;
  if (value - ensuredLower < 0) {
    return value + Math.ceil((ensuredLower - value) / dMinMax) * dMinMax;
  }
  return (value - ensuredLower) % dMinMax + ensuredLower;
}
function hexToRgba(value) {
  const match = value.match(/^#?([0-9a-fA-F]{6})$/);
  if (!match) {
    return null;
  }
  const rv = match[1].slice(0, 2);
  const gv = match[1].slice(2, 4);
  const bv = match[1].slice(4, 6);
  const r = parseInt(rv, 16);
  const g = parseInt(gv, 16);
  const b = parseInt(bv, 16);
  return [r, g, b, 1];
}
function hslaToRgba(h, s, l, alpha = 1) {
  const hc = clip(h, 360, 0, true);
  const sc = clip(s, 100) / 100;
  const lc = clip(l, 100) / 100;
  const k = (n) => (n + hc / 30) % 12;
  const a = sc * Math.min(lc, 1 - lc);
  const f = (n) => lc - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
  return [255 * f(0), 255 * f(8), 255 * f(4), alpha];
}
function keywordColorObject(keyword, units) {
  let toRGBA = () => {
    return [0, 0, 0, 1];
  };
  if (units) {
    const rgba = units.rgba;
    if (rgba) {
      toRGBA = () => rgba;
    }
    const rgb = units.rgb;
    if (rgb) {
      toRGBA = () => [...rgb, 1];
    }
    const hex = units.hex;
    if (hex) {
      toRGBA = () => hexToRgba(hex);
    }
  }
  return __spreadProps(__spreadValues({}, units || {}), {
    name: keyword,
    validator: (value) => value === keyword,
    transformer: (value) => value,
    toRGBA
  });
}
const css1 = {
  hex: {
    name: "hex",
    validator: (value) => /^\s*#?(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})\s*$/.test(value),
    transformer: (value) => {
      const match = value.match(/^\s*#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})\s*$/);
      if (!match) {
        return null;
      }
      if (match[1].length === 3) {
        return `#${match[1][0]}${match[1][0]}${match[1][1]}${match[1][1]}${match[1][2]}${match[1][2]}`;
      }
      return `#${match[1]}`;
    },
    toRGBA: (value) => hexToRgba(value)
  },
  rgb: {
    name: "rgb",
    validator: (value) => rgbRe.test(value),
    transformer: (value) => {
      const match = value.match(rgbRe);
      if (!match) {
        return null;
      }
      const [r, ru] = decimalToValueAndUnit(match[1]);
      const [g, gu] = decimalToValueAndUnit(match[2]);
      const [b, bu] = decimalToValueAndUnit(match[3]);
      const rc = clip(r, ru === "%" ? 100 : 255);
      const gc = clip(g, gu === "%" ? 100 : 255);
      const bc = clip(b, bu === "%" ? 100 : 255);
      return `rgb(${rc}${ru},${gc}${gu},${bc}${bu})`;
    },
    toRGBA: (value) => {
      const match = value.match(rgbRe);
      if (!match) {
        return null;
      }
      const [r, ru] = decimalToValueAndUnit(match[1]);
      const [g, gu] = decimalToValueAndUnit(match[2]);
      const [b, bu] = decimalToValueAndUnit(match[3]);
      const rc = clip(r, ru === "%" ? 100 : 255);
      const gc = clip(g, gu === "%" ? 100 : 255);
      const bc = clip(b, bu === "%" ? 100 : 255);
      const ri = ru === "%" ? Math.round(255 * rc / 100) : r;
      const gi = gu === "%" ? Math.round(255 * gc / 100) : r;
      const bi = bu === "%" ? Math.round(255 * bc / 100) : r;
      return [ri, gi, bi, 1];
    }
  },
  aqua: keywordColorObject("aqua"),
  black: keywordColorObject("black"),
  blue: keywordColorObject("blue"),
  fuchsia: keywordColorObject("fuchsia"),
  gray: keywordColorObject("gray"),
  green: keywordColorObject("green"),
  lime: keywordColorObject("lime"),
  maroon: keywordColorObject("maroon"),
  navy: keywordColorObject("navy"),
  olive: keywordColorObject("olive"),
  purple: keywordColorObject("purple"),
  red: keywordColorObject("red"),
  silver: keywordColorObject("silver"),
  teal: keywordColorObject("teal"),
  white: keywordColorObject("white"),
  yellow: keywordColorObject("yellow")
};
const css2 = {
  hex: css1.hex,
  rgb: css1.rgb,
  aqua: keywordColorObject("aqua", __spreadProps(__spreadValues({}, css1.aqua), { hex: "#00ffff" })),
  black: keywordColorObject("black", __spreadProps(__spreadValues({}, css1.black), { hex: "#000000" })),
  blue: keywordColorObject("blue", __spreadProps(__spreadValues({}, css1.blue), { hex: "#0000ff" })),
  fuchsia: keywordColorObject("fuchsia", __spreadProps(__spreadValues({}, css1.fuchsia), { hex: "#ff00ff" })),
  gray: keywordColorObject("gray", __spreadProps(__spreadValues({}, css1.gray), { hex: "#808080" })),
  green: keywordColorObject("green", __spreadProps(__spreadValues({}, css1.green), { hex: "#008000" })),
  lime: keywordColorObject("lime", __spreadProps(__spreadValues({}, css1.lime), { hex: "#00ff00" })),
  maroon: keywordColorObject("maroon", __spreadProps(__spreadValues({}, css1.maroon), { hex: "#800000" })),
  navy: keywordColorObject("navy", __spreadProps(__spreadValues({}, css1.navy), { hex: "#000080" })),
  olive: keywordColorObject("olive", __spreadProps(__spreadValues({}, css1.olive), { hex: "#808000" })),
  purple: keywordColorObject("purple", __spreadProps(__spreadValues({}, css1.purple), { hex: "#800080" })),
  red: keywordColorObject("red", __spreadProps(__spreadValues({}, css1.red), { hex: "#ff0000" })),
  silver: keywordColorObject("silver", __spreadProps(__spreadValues({}, css1.silver), { hex: "#c0c0c0" })),
  teal: keywordColorObject("teal", __spreadProps(__spreadValues({}, css1.teal), { hex: "#008080" })),
  white: keywordColorObject("white", __spreadProps(__spreadValues({}, css1.white), { hex: "#ffffff" })),
  yellow: keywordColorObject("yellow", __spreadProps(__spreadValues({}, css1.yellow), { hex: "#ffff00" })),
  orange: keywordColorObject("orange", { hex: "#ffa500" })
};
const css3 = {
  hex: css2.hex,
  rgb: css2.rgb,
  aqua: keywordColorObject("aqua", __spreadProps(__spreadValues({}, css2.aqua), { rgb: [0, 255, 255] })),
  black: keywordColorObject("black", __spreadProps(__spreadValues({}, css2.black), { rgb: [0, 0, 0] })),
  blue: keywordColorObject("blue", __spreadProps(__spreadValues({}, css2.blue), { rgb: [0, 0, 255] })),
  fuchsia: keywordColorObject("fuchsia", __spreadProps(__spreadValues({}, css2.fuchsia), { rgb: [255, 0, 255] })),
  gray: keywordColorObject("gray", __spreadProps(__spreadValues({}, css2.gray), { rgb: [128, 128, 128] })),
  green: keywordColorObject("green", __spreadProps(__spreadValues({}, css2.green), { rgb: [0, 128, 0] })),
  lime: keywordColorObject("lime", __spreadProps(__spreadValues({}, css2.lime), { rgb: [0, 255, 0] })),
  maroon: keywordColorObject("maroon", __spreadProps(__spreadValues({}, css2.maroon), { rgb: [128, 0, 0] })),
  navy: keywordColorObject("navy", __spreadProps(__spreadValues({}, css2.navy), { rgb: [0, 0, 128] })),
  olive: keywordColorObject("olive", __spreadProps(__spreadValues({}, css2.olive), { rgb: [128, 128, 0] })),
  orange: keywordColorObject("orange", __spreadProps(__spreadValues({}, css2.orange), { rgb: [255, 165, 0] })),
  purple: keywordColorObject("purple", __spreadProps(__spreadValues({}, css2.purple), { rgb: [128, 0, 128] })),
  red: keywordColorObject("red", __spreadProps(__spreadValues({}, css2.red), { rgb: [255, 0, 0] })),
  silver: keywordColorObject("silver", __spreadProps(__spreadValues({}, css2.silver), { rgb: [192, 192, 192] })),
  teal: keywordColorObject("teal", __spreadProps(__spreadValues({}, css2.teal), { rgb: [0, 128, 128] })),
  white: keywordColorObject("white", __spreadProps(__spreadValues({}, css2.white), { rgb: [255, 255, 255] })),
  yellow: keywordColorObject("yellow", __spreadProps(__spreadValues({}, css2.yellow), { rgb: [255, 255, 0] })),
  rgba: {
    name: "rgba",
    validator: (value) => rgbaRe.test(value),
    transformer: (value) => {
      const match = value.match(rgbaRe);
      if (!match) {
        return null;
      }
      const [r, ru] = decimalToValueAndUnit(match[1]);
      const [g, gu] = decimalToValueAndUnit(match[2]);
      const [b, bu] = decimalToValueAndUnit(match[3]);
      const a = parseFloat(match[4]);
      const rc = clip(r, ru === "%" ? 100 : 255);
      const gc = clip(g, gu === "%" ? 100 : 255);
      const bc = clip(b, bu === "%" ? 100 : 255);
      const ac = clip(a, 1);
      return `rgba(${rc}${ru},${gc}${gu},${bc}${bu},${ac})`;
    },
    toRGBA: (value) => {
      const match = value.match(rgbaRe);
      if (!match) {
        return null;
      }
      const [r, ru] = decimalToValueAndUnit(match[1]);
      const [g, gu] = decimalToValueAndUnit(match[2]);
      const [b, bu] = decimalToValueAndUnit(match[3]);
      const a = parseFloat(match[4]);
      const rc = clip(r, ru === "%" ? 100 : 255);
      const gc = clip(g, gu === "%" ? 100 : 255);
      const bc = clip(b, bu === "%" ? 100 : 255);
      const ac = clip(a, 1);
      const ri = ru === "%" ? Math.round(255 * rc / 100) : rc;
      const gi = gu === "%" ? Math.round(255 * gc / 100) : gc;
      const bi = bu === "%" ? Math.round(255 * bc / 100) : bc;
      return [ri, gi, bi, ac];
    }
  },
  hsl: {
    name: "hsl",
    validator: (value) => hslRe.test(value),
    transformer: (value) => {
      const match = value.match(hslRe);
      if (!match) {
        return null;
      }
      const h = decimalToValueAndUnit(match[1])[0];
      const s = decimalToValueAndUnit(match[2])[0];
      const l = decimalToValueAndUnit(match[3])[0];
      const hc = clip(h, 360, 0, true);
      const sc = clip(s, 100);
      const lc = clip(l, 100);
      return `hsl(${hc},${sc}%,${lc}%)`;
    },
    toRGBA: (value) => {
      const match = value.match(hslRe);
      if (!match) {
        return null;
      }
      const h = decimalToValueAndUnit(match[1])[0];
      const s = decimalToValueAndUnit(match[2])[0];
      const l = decimalToValueAndUnit(match[3])[0];
      return hslaToRgba(h, s, l);
    }
  },
  hsla: {
    name: "hsla",
    validator: (value) => hslaRe.test(value),
    transformer: (value) => {
      const match = value.match(hslaRe);
      if (!match) {
        return null;
      }
      const h = decimalToValueAndUnit(match[1])[0];
      const s = decimalToValueAndUnit(match[2])[0];
      const l = decimalToValueAndUnit(match[3])[0];
      const a = parseFloat(match[4]);
      const hc = clip(h, 360, 0, true);
      const sc = clip(s, 100);
      const lc = clip(l, 100);
      const ac = clip(a, 1);
      return `hsla(${hc},${sc}%,${lc}%,${ac})`;
    },
    toRGBA: (value) => {
      const match = value.match(hslaRe);
      if (!match) {
        return null;
      }
      const h = decimalToValueAndUnit(match[1])[0];
      const s = decimalToValueAndUnit(match[2])[0];
      const l = decimalToValueAndUnit(match[3])[0];
      const a = parseFloat(match[4]);
      return hslaToRgba(h, s, l, a);
    }
  },
  transparent: keywordColorObject("transparent", { rgba: [0, 0, 0, 0] }),
  aliceblue: keywordColorObject("aliceblue", { hex: "#F0F8FF", rgb: [240, 248, 255] }),
  antiquewhite: keywordColorObject("antiquewhite", { hex: "#FAEBD7", rgb: [250, 235, 215] }),
  aquamarine: keywordColorObject("aquamarine", { hex: "#7FFFD4", rgb: [127, 255, 212] }),
  azure: keywordColorObject("azure", { hex: "#F0FFFF", rgb: [240, 255, 255] }),
  beige: keywordColorObject("beige", { hex: "#F5F5DC", rgb: [245, 245, 220] }),
  bisque: keywordColorObject("bisque", { hex: "#FFE4C4", rgb: [255, 228, 196] }),
  blanchedalmond: keywordColorObject("blanchedalmond", { hex: "#FFEBCD", rgb: [255, 235, 205] }),
  blueviolet: keywordColorObject("blueviolet", { hex: "#8A2BE2", rgb: [138, 43, 226] }),
  brown: keywordColorObject("brown", { hex: "#A52A2A", rgb: [165, 42, 42] }),
  burlywood: keywordColorObject("burlywood", { hex: "#DEB887", rgb: [222, 184, 135] }),
  cadetblue: keywordColorObject("cadetblue", { hex: "#5F9EA0", rgb: [95, 158, 160] }),
  chartreuse: keywordColorObject("chartreuse", { hex: "#7FFF00", rgb: [127, 255, 0] }),
  chocolate: keywordColorObject("chocolate", { hex: "#D2691E", rgb: [210, 105, 30] }),
  coral: keywordColorObject("coral", { hex: "#FF7F50", rgb: [255, 127, 80] }),
  cornflowerblue: keywordColorObject("cornflowerblue", { hex: "#6495ED", rgb: [100, 149, 237] }),
  cornsilk: keywordColorObject("cornsilk", { hex: "#FFF8DC", rgb: [255, 248, 220] }),
  crimson: keywordColorObject("crimson", { hex: "#DC143C", rgb: [220, 20, 60] }),
  cyan: keywordColorObject("cyan", { hex: "#00FFFF", rgb: [0, 255, 255] }),
  darkblue: keywordColorObject("darkblue", { hex: "#00008B", rgb: [0, 0, 139] }),
  darkcyan: keywordColorObject("darkcyan", { hex: "#008B8B", rgb: [0, 139, 139] }),
  darkgoldenrod: keywordColorObject("darkgoldenrod", { hex: "#B8860B", rgb: [184, 134, 11] }),
  darkgray: keywordColorObject("darkgray", { hex: "#A9A9A9", rgb: [169, 169, 169] }),
  darkgreen: keywordColorObject("darkgreen", { hex: "#006400", rgb: [0, 100, 0] }),
  darkgrey: keywordColorObject("darkgrey", { hex: "#A9A9A9", rgb: [169, 169, 169] }),
  darkkhaki: keywordColorObject("darkkhaki", { hex: "#BDB76B", rgb: [189, 183, 107] }),
  darkmagenta: keywordColorObject("darkmagenta", { hex: "#8B008B", rgb: [139, 0, 139] }),
  darkolivegreen: keywordColorObject("darkolivegreen", { hex: "#556B2F", rgb: [85, 107, 47] }),
  darkorange: keywordColorObject("darkorange", { hex: "#FF8C00", rgb: [255, 140, 0] }),
  darkorchid: keywordColorObject("darkorchid", { hex: "#9932CC", rgb: [153, 50, 204] }),
  darkred: keywordColorObject("darkred", { hex: "#8B0000", rgb: [139, 0, 0] }),
  darksalmon: keywordColorObject("darksalmon", { hex: "#E9967A", rgb: [233, 150, 122] }),
  darkseagreen: keywordColorObject("darkseagreen", { hex: "#8FBC8F", rgb: [143, 188, 143] }),
  darkslateblue: keywordColorObject("darkslateblue", { hex: "#483D8B", rgb: [72, 61, 139] }),
  darkslategray: keywordColorObject("darkslategray", { hex: "#2F4F4F", rgb: [47, 79, 79] }),
  darkslategrey: keywordColorObject("darkslategrey", { hex: "#2F4F4F", rgb: [47, 79, 79] }),
  darkturquoise: keywordColorObject("darkturquoise", { hex: "#00CED1", rgb: [0, 206, 209] }),
  darkviolet: keywordColorObject("darkviolet", { hex: "#9400D3", rgb: [148, 0, 211] }),
  deeppink: keywordColorObject("deeppink", { hex: "#FF1493", rgb: [255, 20, 147] }),
  deepskyblue: keywordColorObject("deepskyblue", { hex: "#00BFFF", rgb: [0, 191, 255] }),
  dimgray: keywordColorObject("dimgray", { hex: "#696969", rgb: [105, 105, 105] }),
  dimgrey: keywordColorObject("dimgrey", { hex: "#696969", rgb: [105, 105, 105] }),
  dodgerblue: keywordColorObject("dodgerblue", { hex: "#1E90FF", rgb: [30, 144, 255] }),
  firebrick: keywordColorObject("firebrick", { hex: "#B22222", rgb: [178, 34, 34] }),
  floralwhite: keywordColorObject("floralwhite", { hex: "#FFFAF0", rgb: [255, 250, 240] }),
  forestgreen: keywordColorObject("forestgreen", { hex: "#228B22", rgb: [34, 139, 34] }),
  gainsboro: keywordColorObject("gainsboro", { hex: "#DCDCDC", rgb: [220, 220, 220] }),
  ghostwhite: keywordColorObject("ghostwhite", { hex: "#F8F8FF", rgb: [248, 248, 255] }),
  gold: keywordColorObject("gold", { hex: "#FFD700", rgb: [255, 215, 0] }),
  goldenrod: keywordColorObject("goldenrod", { hex: "#DAA520", rgb: [218, 165, 32] }),
  greenyellow: keywordColorObject("greenyellow", { hex: "#ADFF2F", rgb: [173, 255, 47] }),
  grey: keywordColorObject("grey", { hex: "#808080", rgb: [128, 128, 128] }),
  honeydew: keywordColorObject("honeydew", { hex: "#F0FFF0", rgb: [240, 255, 240] }),
  hotpink: keywordColorObject("hotpink", { hex: "#FF69B4", rgb: [255, 105, 180] }),
  indianred: keywordColorObject("indianred", { hex: "#CD5C5C", rgb: [205, 92, 92] }),
  indigo: keywordColorObject("indigo", { hex: "#4B0082", rgb: [75, 0, 130] }),
  ivory: keywordColorObject("ivory", { hex: "#FFFFF0", rgb: [255, 255, 240] }),
  khaki: keywordColorObject("khaki", { hex: "#F0E68C", rgb: [240, 230, 140] }),
  lavender: keywordColorObject("lavender", { hex: "#E6E6FA", rgb: [230, 230, 250] }),
  lavenderblush: keywordColorObject("lavenderblush", { hex: "#FFF0F5", rgb: [255, 240, 245] }),
  lawngreen: keywordColorObject("lawngreen", { hex: "#7CFC00", rgb: [124, 252, 0] }),
  lemonchiffon: keywordColorObject("lemonchiffon", { hex: "#FFFACD", rgb: [255, 250, 205] }),
  lightblue: keywordColorObject("lightblue", { hex: "#ADD8E6", rgb: [173, 216, 230] }),
  lightcoral: keywordColorObject("lightcoral", { hex: "#F08080", rgb: [240, 128, 128] }),
  lightcyan: keywordColorObject("lightcyan", { hex: "#E0FFFF", rgb: [224, 255, 255] }),
  lightgoldenrodyellow: keywordColorObject("lightgoldenrodyellow", { hex: "#FAFAD2", rgb: [250, 250, 210] }),
  lightgray: keywordColorObject("lightgray", { hex: "#D3D3D3", rgb: [211, 211, 211] }),
  lightgreen: keywordColorObject("lightgreen", { hex: "#90EE90", rgb: [144, 238, 144] }),
  lightgrey: keywordColorObject("lightgrey", { hex: "#D3D3D3", rgb: [211, 211, 211] }),
  lightpink: keywordColorObject("lightpink", { hex: "#FFB6C1", rgb: [255, 182, 193] }),
  lightsalmon: keywordColorObject("lightsalmon", { hex: "#FFA07A", rgb: [255, 160, 122] }),
  lightseagreen: keywordColorObject("lightseagreen", { hex: "#20B2AA", rgb: [32, 178, 170] }),
  lightskyblue: keywordColorObject("lightskyblue", { hex: "#87CEFA", rgb: [135, 206, 250] }),
  lightslategray: keywordColorObject("lightslategray", { hex: "#778899", rgb: [119, 136, 153] }),
  lightslategrey: keywordColorObject("lightslategrey", { hex: "#778899", rgb: [119, 136, 153] }),
  lightsteelblue: keywordColorObject("lightsteelblue", { hex: "#B0C4DE", rgb: [176, 196, 222] }),
  lightyellow: keywordColorObject("lightyellow", { hex: "#FFFFE0", rgb: [255, 255, 224] }),
  limegreen: keywordColorObject("limegreen", { hex: "#32CD32", rgb: [50, 205, 50] }),
  linen: keywordColorObject("linen", { hex: "#FAF0E6", rgb: [250, 240, 230] }),
  magenta: keywordColorObject("magenta", { hex: "#FF00FF", rgb: [255, 0, 255] }),
  mediumaquamarine: keywordColorObject("mediumaquamarine", { hex: "#66CDAA", rgb: [102, 205, 170] }),
  mediumblue: keywordColorObject("mediumblue", { hex: "#0000CD", rgb: [0, 0, 205] }),
  mediumorchid: keywordColorObject("mediumorchid", { hex: "#BA55D3", rgb: [186, 85, 211] }),
  mediumpurple: keywordColorObject("mediumpurple", { hex: "#9370DB", rgb: [147, 112, 219] }),
  mediumseagreen: keywordColorObject("mediumseagreen", { hex: "#3CB371", rgb: [60, 179, 113] }),
  mediumslateblue: keywordColorObject("mediumslateblue", { hex: "#7B68EE", rgb: [123, 104, 238] }),
  mediumspringgreen: keywordColorObject("mediumspringgreen", { hex: "#00FA9A", rgb: [0, 250, 154] }),
  mediumturquoise: keywordColorObject("mediumturquoise", { hex: "#48D1CC", rgb: [72, 209, 204] }),
  mediumvioletred: keywordColorObject("mediumvioletred", { hex: "#C71585", rgb: [199, 21, 133] }),
  midnightblue: keywordColorObject("midnightblue", { hex: "#191970", rgb: [25, 25, 112] }),
  mintcream: keywordColorObject("mintcream", { hex: "#F5FFFA", rgb: [245, 255, 250] }),
  mistyrose: keywordColorObject("mistyrose", { hex: "#FFE4E1", rgb: [255, 228, 225] }),
  moccasin: keywordColorObject("moccasin", { hex: "#FFE4B5", rgb: [255, 228, 181] }),
  navajowhite: keywordColorObject("navajowhite", { hex: "#FFDEAD", rgb: [255, 222, 173] }),
  oldlace: keywordColorObject("oldlace", { hex: "#FDF5E6", rgb: [253, 245, 230] }),
  olivedrab: keywordColorObject("olivedrab", { hex: "#6B8E23", rgb: [107, 142, 35] }),
  orangered: keywordColorObject("orangered", { hex: "#FF4500", rgb: [255, 69, 0] }),
  orchid: keywordColorObject("orchid", { hex: "#DA70D6", rgb: [218, 112, 214] }),
  palegoldenrod: keywordColorObject("palegoldenrod", { hex: "#EEE8AA", rgb: [238, 232, 170] }),
  palegreen: keywordColorObject("palegreen", { hex: "#98FB98", rgb: [152, 251, 152] }),
  paleturquoise: keywordColorObject("paleturquoise", { hex: "#AFEEEE", rgb: [175, 238, 238] }),
  palevioletred: keywordColorObject("palevioletred", { hex: "#DB7093", rgb: [219, 112, 147] }),
  papayawhip: keywordColorObject("papayawhip", { hex: "#FFEFD5", rgb: [255, 239, 213] }),
  peachpuff: keywordColorObject("peachpuff", { hex: "#FFDAB9", rgb: [255, 218, 185] }),
  peru: keywordColorObject("peru", { hex: "#CD853F", rgb: [205, 133, 63] }),
  pink: keywordColorObject("pink", { hex: "#FFC0CB", rgb: [255, 192, 203] }),
  plum: keywordColorObject("plum", { hex: "#DDA0DD", rgb: [221, 160, 221] }),
  powderblue: keywordColorObject("powderblue", { hex: "#B0E0E6", rgb: [176, 224, 230] }),
  rosybrown: keywordColorObject("rosybrown", { hex: "#BC8F8F", rgb: [188, 143, 143] }),
  royalblue: keywordColorObject("royalblue", { hex: "#4169E1", rgb: [65, 105, 225] }),
  saddlebrown: keywordColorObject("saddlebrown", { hex: "#8B4513", rgb: [139, 69, 19] }),
  salmon: keywordColorObject("salmon", { hex: "#FA8072", rgb: [250, 128, 114] }),
  sandybrown: keywordColorObject("sandybrown", { hex: "#F4A460", rgb: [244, 164, 96] }),
  seagreen: keywordColorObject("seagreen", { hex: "#2E8B57", rgb: [46, 139, 87] }),
  seashell: keywordColorObject("seashell", { hex: "#FFF5EE", rgb: [255, 245, 238] }),
  sienna: keywordColorObject("sienna", { hex: "#A0522D", rgb: [160, 82, 45] }),
  skyblue: keywordColorObject("skyblue", { hex: "#87CEEB", rgb: [135, 206, 235] }),
  slateblue: keywordColorObject("slateblue", { hex: "#6A5ACD", rgb: [106, 90, 205] }),
  slategray: keywordColorObject("slategray", { hex: "#708090", rgb: [112, 128, 144] }),
  slategrey: keywordColorObject("slategrey", { hex: "#708090", rgb: [112, 128, 144] }),
  snow: keywordColorObject("snow", { hex: "#FFFAFA", rgb: [255, 250, 250] }),
  springgreen: keywordColorObject("springgreen", { hex: "#00FF7F", rgb: [0, 255, 127] }),
  steelblue: keywordColorObject("steelblue", { hex: "#4682B4", rgb: [70, 130, 180] }),
  tan: keywordColorObject("tan", { hex: "#D2B48C", rgb: [210, 180, 140] }),
  thistle: keywordColorObject("thistle", { hex: "#D8BFD8", rgb: [216, 191, 216] }),
  tomato: keywordColorObject("tomato", { hex: "#FF6347", rgb: [255, 99, 71] }),
  turquoise: keywordColorObject("turquoise", { hex: "#40E0D0", rgb: [64, 224, 208] }),
  violet: keywordColorObject("violet", { hex: "#EE82EE", rgb: [238, 130, 238] }),
  wheat: keywordColorObject("wheat", { hex: "#F5DEB3", rgb: [245, 222, 179] }),
  whitesmoke: keywordColorObject("whitesmoke", { hex: "#F5F5F5", rgb: [245, 245, 245] }),
  yellowgreen: keywordColorObject("yellowgreen", { hex: "#9ACD32", rgb: [154, 205, 50] })
};
function matchToCSSSpec(spec, raw) {
  for (const specName in spec) {
    if (spec[specName].validator(raw)) {
      return spec[specName];
    }
  }
  return null;
}
function normalBlendRGBA(source, ...backgrounds) {
  const colorPool = [source, ...backgrounds].reverse().map((value) => [value[0], value[1], value[2], value[3] || 1]);
  const firstFullAlpha = colorPool.findIndex((color) => color[3] >= 1);
  if (firstFullAlpha > 0) {
    colorPool.splice(0, firstFullAlpha);
  }
  let currentBackground = [0, 0, 0, 0];
  let currentSource;
  while (currentSource = colorPool.shift()) {
    const [rs, gs, bs, as] = currentSource;
    const [rb, gb, bb, ab] = currentBackground;
    const ro = as * (1 - ab) * rs + as * ab * rs + (1 - as) * ab * rb;
    const go = as * (1 - ab) * gs + as * ab * gs + (1 - as) * ab * gb;
    const bo = as * (1 - ab) * bs + as * ab * bs + (1 - as) * ab * bb;
    const ao = as + ab * (1 - as);
    currentBackground = [ro, go, bo, ao];
  }
  const rc = Math.round(clip(currentBackground[0] / currentBackground[3], 255));
  const gc = Math.round(clip(currentBackground[1] / currentBackground[3], 255));
  const bc = Math.round(clip(currentBackground[2] / currentBackground[3], 255));
  return [rc, gc, bc, currentBackground[3]];
}
function relativeLuminance(source) {
  const RsRGB = source[0] / 255;
  const GsRGB = source[1] / 255;
  const BsRGB = source[2] / 255;
  const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
  const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
  const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
  return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}
function contrastRatioFromLuminance(luminance1, luminance2) {
  const L1 = Math.max(luminance1, luminance2);
  const L2 = Math.min(luminance1, luminance2);
  return (L1 + 0.05) / (L2 + 0.05);
}
function contrastRatio(rgb8bit1, rgb8bit2) {
  return contrastRatioFromLuminance(relativeLuminance(rgb8bit1), relativeLuminance(rgb8bit2));
}
class Color {
  constructor(color, onTopOf) {
    __publicField(this, "rawColor");
    __publicField(this, "rawBase");
    __publicField(this, "formattedColor");
    __publicField(this, "cssSpec");
    __publicField(this, "rgbaValues");
    this.rawColor = `${color}`;
    const cssSpec = matchToCSSSpec(css3, this.rawColor);
    if (!cssSpec) {
      throw new Error(`Did not recognize color input '${this.rawColor}'`);
    }
    this.cssSpec = cssSpec;
    const formattedColor = this.cssSpec.transformer(this.rawColor);
    if (!formattedColor) {
      throw new Error(`Failed to transform color '${this.rawColor}' into a valid ${this.cssSpec.name} format.`);
    }
    this.formattedColor = formattedColor;
    const rgbaValues = this.cssSpec.toRGBA(this.formattedColor);
    if (!rgbaValues) {
      throw new Error(`Failed to retrieve RGBA values from ${this.cssSpec.name} format of (${this.rawColor}).`);
    }
    this.rgbaValues = rgbaValues;
    if (onTopOf instanceof Color) {
      this.rawBase = onTopOf;
    } else if (typeof onTopOf === "string") {
      this.rawBase = new Color(onTopOf);
    } else {
      this.rawBase = void 0;
    }
  }
  get raw() {
    return this.rawColor;
  }
  get formatted() {
    return this.formattedColor;
  }
  get chainedRgba() {
    if (this.rawBase) {
      return [this.rgbaValues, ...this.rawBase.chainedRgba];
    }
    return [this.rgbaValues];
  }
  get rgba() {
    return normalBlendRGBA(...this.chainedRgba);
  }
  compare(against) {
    const contrast = contrastRatio(this.rgba, against.rgba);
    const wcagConformance = contrast >= 7 ? "aaa" : contrast >= 4.5 ? "aa" : contrast >= 3 ? "a" : false;
    return {
      wcagConformance,
      rawPerceivableValues: {
        contrast
      },
      wcagConformanceLevels: { contrast: { aaa: 7, aa: 4.5, a: 3 } },
      wcagConformancePerPerceivable: { contrast: wcagConformance }
    };
  }
}
export { Color, contrastRatio, contrastRatioFromLuminance, css1, css2, css3, matchToCSSSpec, normalBlendRGBA, relativeLuminance };
